<template>
  <div class="batch-card-header">
    <p :id="'batch-card-header-label-' + index">
      <span class="label">LOTE</span>
      <span class="label-tag">{{ label }}.{{ sequence }}</span>
    </p>

    <p :id="'batch-card-header-date-' + index">
      <span class="label">DATA:</span>
      {{ creationDate | date }}
    </p>

    <p :id="'batch-card-header-barcode-' + index">
      <span class="label">CÓDIGO:</span>
      {{ barcode }}
    </p>

    <p
      v-if="toggle.collectPlace && collectionPointHasValidValue"
      :id="'batch-card-header-collectionPoint-' + index"
      class="ellipsable"
    >
      <span class="label">POSTO:</span>
      <span>
        {{ collectionPlaceName }}
        <md-tooltip md-direction="top">POSTO DE COLETA: {{ collectionPlaceName }}</md-tooltip>
      </span>
    </p>
  </div>
</template>

<script>
import strings from '@/strings'
import Moment from 'moment'
import { COLLECTION_POINT_EMPTY_DEFAULT_VALUE } from '@/enums'
import { mapGetters } from 'vuex'

export default {
  name: 'BatchCardHeader',
  filters: {
    date: function (value) {
      return Moment(value).format('DD-MM-YYYY')
    }
  },
  props: {
    batchState: {
      type: String
    },
    label: {
      type: String,
      default: 0
    },
    sequence: {
      type: String
    },
    barcode: {
      type: String
    },
    creationDate: {
      type: String
    },
    index: {
      type: Number,
      default: 0
    },
    collectionPlaceName: {
      type: String
    }
  },
  computed: {
    ...mapGetters(['toggle']),
    stateName: function () {
      return strings.batchStates[this.batchState].translatedState
    },
    collectionPointHasValidValue: function () {
      return this.collectionPlaceName && this.collectionPlaceName !== COLLECTION_POINT_EMPTY_DEFAULT_VALUE
    }
  }
}
</script>

<style lang="scss">
.batch-card-header {
  color: #7a7a7a;
  font-size: 11px;
  letter-spacing: 0.5px;
  opacity: 1;
  line-height: 16px;
  flex: 80%;
  text-align: left;

  .label {
    font-weight: bold;
    text-transform: capitalize;
  }

  .label-tag {
    width: 54px;
    height: 21px;
    background-color: #4a4a4a;
    border-radius: 2px;
    color: white;
    padding: 4px;
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    margin-left: 9px;
    opacity: 0.93;
  }

  p {
    margin: 7px 0px;
  }

  .ellipsable {
    max-width: 12rem;
  }
}
</style>
